import $ from "jquery";

// The design SVGs are inlined once in the hidden #svg-bank element of the
// page (see edl.twig.html). Runtime-built visuals clone them from there, so
// no SVG markup lives in JS.

let gradientUid = 0;
let idUid = 0;

export function cloneSvg(name) {
  const $svg = $(`#svg-bank [data-svg="${name}"] svg`).first().clone();
  if (!$svg.length) console.warn(`SVG "${name}" not found in #svg-bank`);
  uniquifyIds($svg);
  return $svg;
}

// A copy carries the same ids as the original it came from, and the browser
// then points its gradients and clip paths back at the hidden original, which
// leaves the copy blank. Renaming the ids of the copy, and the references to
// them, keeps it looking at its own.
function uniquifyIds($svg) {
  $svg.find("[id]").each((i, el) => {
    const oldId = el.id;
    const newId = `svg-bank-id-${++idUid}`;
    el.id = newId;

    ["fill", "stroke", "clip-path"].forEach((attr) => {
      $svg.find(`[${attr}="url(#${oldId})"]`).attr(attr, `url(#${newId})`);
    });
  });
}

// Recolors one shape of a copied SVG from the color of the JSON: a list of
// colors makes a gradient with the colors evenly spread, a single one a flat
// fill. The gradient of the design file is reused, renamed so two copies never
// fight over it.
export function setFillColors($svg, $el, color) {
  const colors = [].concat(color || []);
  if (!colors.length || !$el.length) return;

  const $gradient = $svg.find("linearGradient");

  if (colors.length === 1 || !$gradient.length) {
    $el.attr("fill", colors[0]);
    $svg.find("defs").remove();
    return;
  }

  const id = `svg-bank-gradient-${++gradientUid}`;
  $gradient.attr("id", id).empty();

  colors.forEach((stopColor, i) => {
    const stop = document.createElementNS("http://www.w3.org/2000/svg", "stop");
    stop.setAttribute("offset", i / (colors.length - 1));
    stop.setAttribute("stop-color", stopColor);
    $gradient.append(stop);
  });

  $el.attr("fill", `url(#${id})`);
}
